export default __webpack_public_path__ + "static/media/Spin torre RI_Interactive LightMix0059.71a499a2.webp";